import { z } from 'zod';

export const HallTable = z.object({
  id: z.string(),
  name: z.string(),
  seats: z.number().int(),
  /** правило стола: null — брать зальное или общее, 0 — не брать */
  servicePct: z.number().int().nullable().optional(),
  discountPct: z.number().int().nullable().optional(),
  /** служебный стол «Ошибки»: не место для гостей, только для переноса */
  isVirtual: z.boolean().optional(),
});

export const HallMap = z.array(z.object({
  id: z.string(),
  name: z.string(),
  /** правила всего зала: у бара сбора нет, у веранды свой процент */
  servicePct: z.number().int().nullable().optional(),
  discountPct: z.number().int().nullable().optional(),
  tables: z.array(HallTable),
}));
export type HallMap = z.infer<typeof HallMap>;

export const UpsertHall = z.object({
  name: z.string().min(1).max(40),
  isActive: z.boolean().optional(),
  /**
   * Сбор и скидка всего зала. null — брать общее по заведению,
   * 0 — не брать вовсе. Это разные вещи: у бара сбора нет,
   * а у веранды он просто не задан отдельно
   */
  servicePct: z.number().int().min(0).max(30).nullable().optional(),
  discountPct: z.number().int().min(0).max(100).nullable().optional(),
});
export type UpsertHall = z.infer<typeof UpsertHall>;

export const UpsertTable = z.object({
  name: z.string().min(1).max(20),
  seats: z.number().int().min(1).max(50),
  isActive: z.boolean().optional(),
  /** Своё правило стола важнее зального: столы «шеф», служебные */
  servicePct: z.number().int().min(0).max(30).nullable().optional(),
  discountPct: z.number().int().min(0).max(100).nullable().optional(),
});
export type UpsertTable = z.infer<typeof UpsertTable>;
